export type {
  TabProps,
  TabsProps,
} from "@components/contracts/Tabs.types";
export { RsuiteTab, RsuiteTabs } from "./Tabs.adapter";
